export default "__VITE_ASSET__CLptICqh__"